import "reflect-metadata";
import "regenerator-runtime/runtime";

import "@wagich/bluc-backendapp/dist/style.css";
import { App } from "@wagich/bluc-backendapp";

import { mdiFormSelect } from "@mdi/js";

import { ContactForm } from "./contact-form";

if (document.querySelector("[app]") != null) {
	const app = App.create({
		configureAuth: options => {
			options.authority = "https://identity.bluc.io";
			options.client_id = "stockhorn-bluc";
			options.scope = "openid profile bluc stockhorn-bluc-api";
		},
		configureRichtext: options => {
			options.assetSizes = [
				{
					name: "thumbnail",
					displayName: "Thumbnail"
				},
				{
					name: "small",
					displayName: "Klein"
				},
				{
					name: "large",
					displayName: "Gross"
				},
			];
			options.customElements.push({
				name: "Kontaktformular",
				expandOnToolbar: true,
				extension: ContactForm,
				createCommand: editor => editor.commands.insertContactForm(),
				iconSvg: mdiFormSelect,
			});
		},
		configureMenu: options => {
			options.controllers = [
				{
					displayName: "Standard",
					name: "Default",
					actions: [
						{
							displayName: "Kalender",
							name: "Calendar"
						}
					]
				},
				{
					displayName: "Broschüren",
					name: "BrochureOrder",
				}
			];
		}
	});

	app.mount("[app]");
}
